var FormSubsidy = (function ($) {

    var FormSubsidy = function (options) {
        var that = this;

        that.selectors = {
            block_subsidy_type: '.js-subsidy-type-block',
            block_subsidy_type_student: '.js-subsidy-type-student-block',
            block_subsidy_type_citizen: '.js-subsidy-type-citizen-block',
            block_subsidy_type_fixed_age: '.js-subsidy-type-fixed-age-block',
            block_subsidy_type_invalids: '.js-subsidy-type-invalids-block',
            block_subsidy_type_big_family: '.js-subsidy-type-big-family-block',

            subsidy_type: '.js-toggle-subsidy-type-input',
            subsidy_direction_input: '.js-subsidy-direction-input',
            subsidy_airport_departure: '.js-subsidy-airport-departure',
            subsidy_airport_arrival: '.js-subsidy-airport-arrival',
            subsidy_airport_departure_input: '.js-subsidy-airport-departure-input',
            subsidy_return_date: '.js-subsidy-return-date',
            subsidy_return_date_input: '.js-subsidy-return-date-input',
            subsidy_return_date_diapason: '.js-subsidy-return-date-diapason',

            subsidy_passenger: '.js-subsidy-passenger',
            subsidy_passenger_index: '.js-subsidy-passenger-index',
            subsidy_passenger_remove_button: '.js-subsidy-passenger-remove-button',
            subsidy_passenger_add_button: '.js-subsidy-passenger-add-button',

            subsidy_passenger_lastname: '.js-subsidy-passenger-lastname',
            subsidy_passenger_name: '.js-subsidy-passenger-name',
            subsidy_passenger_middlename: '.js-subsidy-passenger-middlename',
            subsidy_passenger_sex: '.js-subsidy-passenger-sex',
            subsidy_passenger_birthdate: '.js-subsidy-passenger-birthdate',
            subsidy_passenger_citizenship: '.js-subsidy-passenger-citizenship',
            subsidy_passenger_document: '.js-subsidy-passenger-document',
            subsidy_passenger_document_number: '.js-subsidy-passenger-document-number',

            input_files: '.js-file-elem',
        }

        // DOM
        that.$wrapper = options["$wrapper"];

        that.$block_subsidy_type = that.$wrapper.find(that.selectors.block_subsidy_type);
        that.$block_subsidy_type_student = that.$wrapper.find(that.selectors.block_subsidy_type_student);
        that.$block_subsidy_type_citizen = that.$wrapper.find(that.selectors.block_subsidy_type_citizen);
        that.$block_subsidy_type_fixed_age = that.$wrapper.find(that.selectors.block_subsidy_type_fixed_age);
        that.$block_subsidy_type_invalids = that.$wrapper.find(that.selectors.block_subsidy_type_invalids);
        that.$block_subsidy_type_big_family = that.$wrapper.find(that.selectors.block_subsidy_type_big_family);

        that.$subsidy_airport_departure = that.$wrapper.find(that.selectors.subsidy_airport_departure);
        that.$subsidy_airport_arrival = that.$wrapper.find(that.selectors.subsidy_airport_arrival);
        that.$subsidy_return_date = that.$wrapper.find(that.selectors.subsidy_return_date);
        that.$subsidy_return_date_input = that.$wrapper.find(that.selectors.subsidy_return_date_input);
        that.$subsidy_return_date_diapason = that.$wrapper.find(that.selectors.subsidy_return_date_diapason);

        that.$block_subsidy_passenger = that.$wrapper.find(that.selectors.subsidy_passenger);
        that.$copied_subsidy_passenger_template = that.$block_subsidy_passenger.clone()

        // DYNAMIC VARS
        that.locales = options['locales'] || {};

        that.student_option_id = options['student_option_id'] || '';
        that.citizen_option_id = options['citizen_option_id'] || '';
        that.under_23_age_option_id = options['under_23_age_option_id'] || '';
        that.senior_citizen_option_id = options['senior_citizen_option_id'] || '';
        that.invalid_any_age_1_and_escort_option_id = options['invalid_any_age_1_and_escort_option_id'] || '';
        that.chid_invalid_and_escort_option_id = options['chid_invalid_and_escort_option_id'] || '';
        that.childhood_invalid_2_3_option_id = options['childhood_invalid_2_3_option_id'] || '';
        that.large_family_and_support_doc_option_id = options['large_family_and_support_doc_option_id'] || '';

        that.direction_rt_option_id = options['direction_rt_option_id'] || '';

        that.flights_variants_by_type = options['flights_variants_by_type'] || {};
        that.airports = options['airports'] || {};

        that.flights_variants = {};

        // INIT
        that.init(options);
    };

    var Self = FormSubsidy;
    Self.className = 'FormSubsidy';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id;

            that.$wrapper.find('.js-form-subsidy').hide();
            that.$wrapper.find('.js-success-result').show();
            that.$wrapper.find('.js-unique-id').text(unique_id);

            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }

        Parent.prototype.init.call(that, options);

        that.initToggles();

        that.initGroups();

        that.initInputMask();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            ...that.selectors,
            form: '.js-form-subsidy',
            previous_action: '',
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initDateMask(that.$wrapper);
    }

    Self.prototype.initToggles = function () {
        var that = this;

        that.initSubsidyTypeToggle();
        that.initSubsidyDirectionToggle();
        that.initSubsidyAirportDepartureToggle();
    }

    Self.prototype.getAirportLabel = function (airport) {
        var that = this,
            data = that.airports[airport] || {},
            locale = $.sa.current_locale_config.code,
            locale_code = $.sa.current_locale_config.code === 'en' ? '' : '_' + locale,
            city_name = data['city_name' + locale_code] || airport;

        return city_name + ' (' + airport + ')';
    }

    Self.prototype.makeAirportDepartureOptions = function (selected_type) {
        var that = this,
            flights_variants = that.flights_variants_by_type[selected_type] || {},
            options = Object.keys(flights_variants).map(function (airport) {
                return { value: airport, label: that.getAirportLabel(airport) }
            });

        that.flights_variants = flights_variants;

        // Добавляем опции в селектор
        UISelect.prototype.__clearValue(that.$subsidy_airport_departure);
        UISelect.prototype.makeOptionsFromArray(that.$subsidy_airport_departure, options);

        // Запрещаем редактирование другого
        UISelect.prototype.__clearValue(that.$subsidy_airport_arrival);
        UISelect.prototype.__disabled(that.$subsidy_airport_arrival);
    }

    Self.prototype.makeAirportArrivalOptions = function (airport_departure) {
        var that = this,
            arrival_airports = that.flights_variants[airport_departure] || [],
            options = arrival_airports.map(function (airport) {
                return { value: airport, label: that.getAirportLabel(airport) }
            });

        // Разрешаем редактирование другого
        UISelect.prototype.__clearValue(that.$subsidy_airport_arrival);
        UISelect.prototype.__disabled(that.$subsidy_airport_arrival, false);

        // Добавляем опции в селектор
        UISelect.prototype.__clearValue(that.$subsidy_airport_arrival);
        UISelect.prototype.makeOptionsFromArray(that.$subsidy_airport_arrival, options);
    }

    Self.prototype.initSubsidyTypeToggle = function () {
        var that = this;

        $.sa.$document.on('change', that.selectors.subsidy_type, function (e) {
            var $toggle_select = $(e.target),
                selected_type = $toggle_select.val();

            if (selected_type && $toggle_select.hasClass(that.selectors.subsidy_type.substring(1))) {
                that.$block_subsidy_type.show();

                that.$block_subsidy_type_citizen.hide();
                that.$block_subsidy_type_student.hide();
                that.$block_subsidy_type_fixed_age.hide();
                that.$block_subsidy_type_invalids.hide();
                that.$block_subsidy_type_big_family.hide();

                if (selected_type === that.student_option_id) {
                    that.$block_subsidy_type_student.show();
                } else if (selected_type === that.citizen_option_id) {
                    that.$block_subsidy_type_citizen.show();
                } else if (selected_type === that.under_23_age_option_id || selected_type === that.senior_citizen_option_id) {
                    that.$block_subsidy_type_fixed_age.show();
                } else if (selected_type === that.invalid_any_age_1_and_escort_option_id || selected_type === that.chid_invalid_and_escort_option_id || selected_type === that.childhood_invalid_2_3_option_id) {
                    that.$block_subsidy_type_invalids.show();
                } else if (selected_type === that.large_family_and_support_doc_option_id) {
                    that.$block_subsidy_type_big_family.show();
                }

                that.makeAirportDepartureOptions(selected_type);

                that.$wrapper.find(that.selectors.input_files).attr('name', 'files[]');
            }

        });
    }

    Self.prototype.initSubsidyAirportDepartureToggle = function () {
        var that = this;

        $.sa.$document.on('change', that.selectors.subsidy_airport_departure_input, function (e) {
            var $toggle_input = $(e.target),
                airport_departure = $toggle_input.val();

            if (airport_departure && $toggle_input.hasClass(that.selectors.subsidy_airport_departure_input.substring(1))) {
                that.makeAirportArrivalOptions(airport_departure);
            }

        });
    }

    Self.prototype.initSubsidyDirectionToggle = function () {
        var that = this;

        $.sa.$document.on('change', that.selectors.subsidy_direction_input, function (e) {
            var $toggle_radio = $(e.target),
                direction = $toggle_radio.val();

            if (direction && $toggle_radio.hasClass(that.selectors.subsidy_direction_input.substring(1))) {
                that.$subsidy_return_date.hide();

                if (direction === that.direction_rt_option_id) {
                    that.$subsidy_return_date.show();
                } else {
                    that.$subsidy_return_date_input.val('').trigger('input').change();
                    UIInputMask.prototype.initDateMask(that.$wrapper);

                    UICheckbox.prototype.__clearValue(that.$subsidy_return_date_diapason);
                }
            }

        });
    }

    Self.prototype.initGroups = function () {
        var that = this;

        that.setIndexInRoute = function () {
            var $subsidy_passenger_blocks = that.$wrapper.find(that.selectors.subsidy_passenger)
            $subsidy_passenger_blocks.each(function (index) {
                var set_index = index + 1
                var $block = $(this)

                $block.find(that.selectors.subsidy_passenger_index).text(set_index === 1 ? '' : '№' + set_index)
                $block.find(that.selectors.subsidy_passenger_lastname).attr('name', 'passenger[' + set_index + '][last_name]')
                $block.find(that.selectors.subsidy_passenger_name).attr('name', 'passenger[' + set_index + '][name]')
                $block.find(that.selectors.subsidy_passenger_middlename).attr('name', 'passenger[' + set_index + '][middle_name]')
                $block.find(that.selectors.subsidy_passenger_sex).attr('name', 'passenger[' + set_index + '][sex]')
                $block.find(that.selectors.subsidy_passenger_birthdate).attr('name', 'passenger[' + set_index + '][birthdate]')
                $block.find(that.selectors.subsidy_passenger_citizenship).attr('name', 'passenger[' + set_index + '][citizenship]')
                $block.find(that.selectors.subsidy_passenger_document).attr('name', 'passenger[' + set_index + '][document]')
                $block.find(that.selectors.subsidy_passenger_document_number).attr('name', 'passenger[' + set_index + '][document_number]')
            })
        }

        that.initGroupBlocks(
            that.selectors.subsidy_passenger,
            that.selectors.subsidy_passenger_add_button,
            that.selectors.subsidy_passenger_remove_button,
            that.$copied_subsidy_passenger_template,
            function () {
                UIInputMask.prototype.initDateMask(that.$wrapper);
                that.setIndexInRoute()
            }
        )
    }

    return Self;
})(jQuery);